import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import type { BulkAdDaypartingUpdate } from "../../../zodios/apiDefinitions/api/ads";
import { errorToast, successToast } from "../../../utils/toasts";

export function useBulkUpdateDayparting() {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["advertising"]);
  return useMutation({
    mutationFn: async (vars: BulkAdDaypartingUpdate) => {
      await apiClient.updateDayparting(vars);
    },
    onSuccess: (data, vars) => {
      successToast({
        message: t(($) => $.advertising["Media Plans Updated"], { count: vars.advertisement_ids.length }),
      });
      // TODO: shouldn't invalidate _all_ queries
      void queryClient.invalidateQueries();
    },
    onError: (error, vars) => {
      errorToast({
        message: t(($) => $.advertising["Failed to update Media Plans"], { count: vars.advertisement_ids.length }),
        error,
      });
    },
  });
}
